import React, { useState } from 'react'
import { Box } from '@mui/material'

import { TextInput } from '~components/common'
import { isValidEmail } from '~utils/emailUtils'

interface EmailEntryBoxProps {
  inputEmailAddress: string
  onChange: (newEmail: string, newIsValid: boolean) => void
  disableHelperText?: boolean
}

const EmailEntryBox: React.FC<EmailEntryBoxProps> = ({
  inputEmailAddress,
  onChange,
  disableHelperText,
}) => {
  const [emailAddress, setEmailAddress] = useState<string>(inputEmailAddress)
  const [blurred, setBlurred] = useState(false)

  const isValid = isValidEmail(emailAddress)
  const showError = blurred && !isValid && emailAddress.length > 0

  const handleEmailAddressChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const newEmailAddress = event.target.value
    setEmailAddress(newEmailAddress)
    onChange(newEmailAddress, isValidEmail(newEmailAddress))
  }

  const handleBlur = (): void => {
    setBlurred(true)
  }

  const handleFocus = (): void => {
    setBlurred(false)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <TextInput
        value={inputEmailAddress}
        type='email'
        onBlur={handleBlur}
        onFocus={handleFocus}
        onChange={handleEmailAddressChange}
        error={showError}
        errorText='Please enter a valid email address'
        disableHelperText={disableHelperText}
      />
    </Box>
  )
}

export default EmailEntryBox
